const InputValidation = {

// Limit phone and zip code input to integers, dashes and white space.
ValidateInputForPhoneAndZipCode: function(text) {
   console.log("Validate Number Input")
   try {
      const condition = /[0-9]-*$|[0-9]\s*$/g
      if(condition.test(text)){
         console.log("Match", text)
         return text
      }
      else{
         console.log("No match", text)
         return text.slice(0, -1);
      }
   } catch (error) {
      console.log(error)
   }
},

// Limit insurance ID and group policy number input to integers and letters only.
ValidateInputForInsuranceNumbers: function(text) {
   console.log("Validate Number Input")
   try {
      const condition = /[a-zA-Z0-9\s-]$/
      if(condition.test(text)){
         console.log("Match", text)
         return text
      }
      else{
         console.log("No match", text)
         return text.slice(0, -1);
      }
   } catch (error) {
      console.log(error)
   }
},

shiftDecimalLeft: function (number, places) {
   return number / Math.pow(10, places);
 }

}
export default InputValidation